import { Fragment, useRef, useState } from 'react'
import { faEllipsisStrokeVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisStrokeVertical'
import { useCookie } from 'src/hook/useCookie'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { useClickOutside } from 'src/hook/useClickOutside'
import {
  ActionButton,
  ButtonIcon,
  CustomIcon,
  DropdownItemText,
  DropdownWrapper
} from './dropdownActions.styles'
import { DropdownActionsProps } from './dropdownActions.types'

const DropdownActions = ({
  triggerIcon = faEllipsisStrokeVertical,
  items
}: DropdownActionsProps) => {
  const [visible, setVisibile] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const { value: theme } = useCookie<ThemeMode>({
    name: 'theme',
    defaultValue: ThemeMode.DARK,
    observeChanges: true
  })
  useClickOutside(ref, handleCloseDropdown)

  function handleCloseDropdown() {
    setVisibile(false)
  }

  function handleToggleVisibility() {
    setVisibile((prevState) => !prevState)
  }

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault()
    event.stopPropagation()
    handleToggleVisibility()
  }

  function handleDropdownItemClick(
    event: React.MouseEvent<HTMLButtonElement>,
    callback: () => void
  ) {
    event.preventDefault()
    event.stopPropagation()
    handleCloseDropdown()
    callback()
  }

  return (
    <div ref={ref} className="_d-flex _flex-column _align-items-end _position-relative">
      <ActionButton
        className="hot-button _d-flex _align-items-center _border-0"
        onClickCapture={handleClick}
      >
        <span className="_sr-only">context menu icon</span>
        <ButtonIcon icon={triggerIcon} className="_text-gray-900" />
      </ActionButton>

      {visible && (
        <div className="_d-flex _flex-column _align-items-end">
          <DropdownWrapper
            theme={theme}
            className="_d-flex _flex-column _position-fixed _rounded-lg _mt-2 _ml-2"
          >
            {items.map((item) => (
              <Fragment key={item.label}>
                {item.visible && (
                  <button
                    className="_d-flex _align-items-center _border-0 hot-button _px-4 _py-5"
                    onClickCapture={(event) => handleDropdownItemClick(event, item.callback)}
                  >
                    {item?.icon && <CustomIcon icon={item.icon} className="_text-gray-900 _mr-4" />}
                    <DropdownItemText className="_text-left">{item.label}</DropdownItemText>
                  </button>
                )}
              </Fragment>
            ))}
          </DropdownWrapper>
        </div>
      )}
    </div>
  )
}

export default DropdownActions
